const COPY_ALLOWED_EMAIL = "udgttl12@naver.com"
const TEST_PAGE_SELECTOR = ".interview-test-page, .ocr-app"

export function shouldPreventTextSelection(target, userEmail) {
  if (userEmail === COPY_ALLOWED_EMAIL) return false
  if (typeof target?.closest !== "function") return true
  return !target.closest(TEST_PAGE_SELECTOR)
}
